import _ from 'lodash';
import { IObservableArray, makeAutoObservable, observable } from 'mobx';
import moment from 'moment';
import { CardFormConfig, checkCardFromRule } from '../../../component/card/card-from';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import { Restaurant, Staff } from '../../../models';
import apiManage from '../../../request';
import { authGroupData } from '../auth-group/auth-group';
import { groupUnitData } from '../group-unit';

class EditAccountMobx {

    constructor() {
        makeAutoObservable(this);
    }

    disabled: boolean = false


    editingStaff: Staff | null = null;
    viewStaffBaseInfo: Staff | null = null;
    sourceStaffBaseInfo: Staff | null = null;
    @observable op: Map<string, { old: string, now: string }> = new Map();
    dialog: any = {
        open: false,
        title: i18n.t('general_text_tips'),
    };
    modifyBaseInfo: boolean = false;
    // 允许空校验 - 输入框校验
    allowNullVerification: boolean = false;

    updateAllowNullVerification(val: boolean) {
        this.allowNullVerification = val;
    }

    setDiglog(value: any) {
        this.dialog = value
    }

    // call from base info tsx
    async getAccountInfo(id: string | undefined) {
        if (!id) return
        const data = await apiManage.get_staff_id(id, this.disabled ? true : undefined);
        if ('error' in data) {

        } else {
            this.updateStaffInfo(data)
        }
    }

    updateStaffInfo(staff: Staff) {
        staff.password = '';
        this.viewStaffBaseInfo = staff;
        this.sourceStaffBaseInfo = _.cloneDeep(staff);
    }

    updateDisable(v: boolean) {
        this.disabled = v
    }

    // when edit account page enter
    updateEditing(staff: Staff | null) {
        if (staff) this.editingStaff = staff;
        else {
            // 创建账号
            this.editingStaff = null;
            this.viewStaffBaseInfo = {
                nickname: '',
                phone_prefix: '39',
                phone: '',
                email: '',
                first_name: '',
                last_name: '',
                gender: '',
                birth: '',
                password: ''
            }
            this.sourceStaffBaseInfo = _.cloneDeep(this.viewStaffBaseInfo)
        }
    }

    handleChangeViewStaffBaseInfo(e: any, keyName: string) {
        const now = e.target.value;
        const old: string = this.sourceStaffBaseInfo![keyName as keyof Staff] as string
        if (!_.isEqual(old, now)) this.op.set(keyName, { old, now })
        else this.op.delete(keyName);
        this.viewStaffBaseInfo![keyName as keyof Staff] = now;
        this.checkBaseInfoOP();
    }

    async save(accountInfoCardConfig: CardFormConfig[]) {
        const errorList = checkCardFromRule({ config: accountInfoCardConfig, data: this.viewStaffBaseInfo as unknown as {} })
        if (errorList.length) {
            this.updateAllowNullVerification(true);
            return false;
        }

        if (this.editingStaff === null) {
            // 创建
            const data = this.viewStaffBaseInfo;
            const params = {
                nickname: (data?.first_name ?? '') + (data?.last_name ?? ''),
                phone_prefix: data?.phone_prefix,
                phone: data?.phone,
                email: data?.email || undefined,
                first_name: data?.first_name,
                last_name: data?.last_name,
                gender: data?.gender || undefined,
                birth: data?.birth ? moment(data?.birth).utc().format() : undefined,
                password: data?.password,
                belonged_group: groupUnitData.belongedGroup
            }
            const res = await apiManage.create_staff(params);

            if ('error' in res) {
                if (_.get(res.result, 'message').includes('Already')) {
                    GlobalNotification.error(i18n.t('edit_account_auth_exist'));
                } else {
                    GlobalNotification.error(i18n.t('dish_identify_page_msg_create_failed'));
                }
                return false
            } else {
                GlobalNotification.success(i18n.t('dish_identify_page_msg_create_succeed'));
                if (this.iconTempFile) {
                    await this.onChangeLogo(this.iconTempFile, res.upsertedId._id);
                }
                await authGroupData.save(res.upsertedId?._id || '')
                this.op = new Map();
                groupUnitData.getStaffsData();
                return true
            }
        } else {
            // 编辑
            // eslint-disable-next-line
            const [isChanged, outputString, baseInfoCheck, authGroupCheck] = this.checkTheEntireChange();
            if (baseInfoCheck) {
                const res = await this.saveBaseInfo();
                if ('error' in res) {
                    if (res.result.code === 1008) {
                        GlobalNotification.error(i18n.t('edit_account_auth_exist'));
                    } else {
                        GlobalNotification.error(i18n.t('general_text_modify_failed'));
                    }
                    return false
                } else {
                    GlobalNotification.success(i18n.t('general_text_modify_success'));
                    this.op.clear();
                    return true
                }
            }
            if (authGroupCheck) {
                try {
                    await authGroupData.save()
                    return true
                } catch (error) {
                    GlobalNotification.error(i18n.t('general_text_modify_failed'));
                    return false
                }
            } else {
                return true
            }
        }
    }

    /**
     * 初始化密码
     */
    async initializePassword() {
        const result = await apiManage.post_staff_id_password_initialize({ _id: this.editingStaff?._id || '' });
        if ('error' in result) {
            GlobalNotification.error(i18n.t('ground_staff_component_text_initialization_failure'));
        } else {
            GlobalNotification.success(i18n.t('ground_staff_component_text_successful_initialization'));
        }
    }

    async saveBaseInfo() {
        const data = this.viewStaffBaseInfo!;
        // 只传修改了的值
        const params: { nickname?: string } = {};
        // return;
        this.op.forEach((value, key) => {
            let newValue = value.now;
            if (key === 'birth') {
                newValue = moment(data.birth).utc().format()
            } else if (key === 'first_name' || key === 'last_name') {
                params.nickname = (data.first_name ?? '') + (data.last_name ?? '');
            }
            params[key] = newValue
        })
        const res = await apiManage.patch_staff_id_id(({ ...params, _id: this.editingStaff?._id, }))
        return res
    }

    checkBaseInfoOP() {
        if (this.op.size !== 0) {
            this.modifyBaseInfo = true;
            return true;
        } else {
            this.modifyBaseInfo = true;
            return false
        }
    }
    /**
     * 校验是否有变更数据
     */
    checkTheEntireChange(): [boolean, string[], boolean, boolean] {
        const baseInfoCheck = this.checkBaseInfoOP() ? `${i18n.t('dialog_text_baseinfo_had_modified')}\n` : '';
        const authGroupCheck = authGroupData.checkModify() ? `${i18n.t('dialog_text_auth_setting_had_modified')}\n` : '';
        const outputStrings = [baseInfoCheck, authGroupCheck];
        if (baseInfoCheck.length > 0 || authGroupCheck.length > 0)
            return [true, outputStrings, baseInfoCheck.length > 0, authGroupCheck.length > 0]
        else return [false, [], false, false]
    }

    close() {
        this.dialog = { open: false }
        return true;
        // $ 该组件 暂时不需要，校验是否有更改
        // const [isChanged, outputStrings] = this.checkTheEntireChange();

        // if (isChanged) {
        //     this.dialog = {
        //         title: i18n.t('general_text_tips'),
        //         open: true,
        //         message: outputStrings,
        //         option: [
        //             [i18n.t('dialog_text_save_and_close'), ({ onClose }: { onClose: () => void }) => {
        //                 this.save(accountInfoCardConfig);
        //                 onClose();
        //                 this.setDiglog({ open: false });
        //                 this.reset();
        //                 groupUnitData.getStaffsData();
        //             }],
        //             [i18n.t('dialog_text_close_without_close'), ({ onClose }: { onClose: () => void }) => {
        //                 onClose();
        //                 this.setDiglog({ open: false });
        //                 this.reset();
        //             }]
        //         ]
        //     }
        //     return false;
        // } else {
        //     // 无修改
        //     this.dialog = { open: false }
        //     return true;
        // }
    }

    reset() {
        this.editingStaff = null;
        this.viewStaffBaseInfo = null;
        this.sourceStaffBaseInfo = null;
        this.modifyBaseInfo = false;
        this.op = new Map();
        this.allowNullVerification = false;
        this.iconTempFile = null
    }

    iconTempFile: File | null = null

    async onChangeLogo(file: File, _id?: string) {
        // 头像有改动才上传
        if ((file && this.editingStaff?._id) || (file && _id)) {
            const result = await apiManage.patch_staff_id_avatar(this.editingStaff?._id ?? _id ?? '', file)
            if (!('error' in result)) {
                const avatar = result.ossResult.url;
                this.updateStaffInfo({ ...this.editingStaff, avatar });
                if (this.iconTempFile) {
                    this.iconTempFile = null;
                }
            } else {
                GlobalNotification.error(i18n.t('edit_account_icon_modify_failed'));
            }
        } else {
            // 新增账号时，暂存头像file
            // 上传图片
            if (file) {
                this.iconTempFile = file;
            }
        }
    }

    onOpenCreateNewStaffInit() {
        this.viewStaffBaseInfo = {};
        this.sourceStaffBaseInfo = {};
    }

    // --------------- 绑定餐厅 -----------------
    // ------------ start-region ---------------
    async openCanCombindRestaurant() {
        this.canCombindRestaurantData.selectValue = 'nickname';
        this.canCombindRestaurantData.groupSelectVal = 'belonged_group';
        this.setViewCanCombindRestaurantDialog(true);
        this.setTableLoading(true);
        const params = {
            is_belonged_group: this.canCombindRestaurantData.groupSelectVal === 'belonged_group' ? true : false,
            belonged_group: groupUnitData.belongedGroup,
            pagination_per_page: this.canCombindRestaurantData.paginationPerPage,
            pagination_page: this.canCombindRestaurantData.currentPage,
        };
        const data = await apiManage.get_restaurant_condition(params);
        this.updateCanCombindRestaurantList(data);
        this.setTableLoading(false);
    }
    setViewCanCombindRestaurantDialog(value: boolean) {
        this.canCombindRestaurantData.open = value
    }
    setTableLoading(value: boolean) {
        this.canCombindRestaurantData.isLoading = value
    }
    // 绑定/解绑餐厅
    async combineOrNotRestaurant(row: Restaurant, isCombine: boolean) {
        this.setTableLoading(true);
        const params = {
            _id: this.viewStaffBaseInfo!._id || '',
            belonged_restaurant: [row?.string_id || ''],
            type: isCombine ? 'REMOVE' : 'ADD',
        }
        await apiManage.patch_staff_id_belonged_restaurant(params);
        await this.getAccountInfo(this.editingStaff?._id);
        this.setTableLoading(false);
    }
    updateCanCombindRestaurantList(value: any) {
        this.canCombindRestaurantData.list.replace(value[0].dbResults);
        this.canCombindRestaurantData.totalCount = value[0].totalCount[0]?.count ?? 0;
    }
    updateSearchSelectValue(value: string) {
        this.canCombindRestaurantData.selectValue = value;
    }
    updateGroupSelectValue(value: string) {
        this.canCombindRestaurantData.groupSelectVal = value;
    }
    updateCurrentSearchString(value: string) {
        this.canCombindRestaurantData.currentSearchValue = value;
    }
    async searchCanCombineRestaurant(value: string) {
        console.log('selectValue: ', this.canCombindRestaurantData.selectValue);
        this.setTableLoading(true);
        let obj = {}
        const key = this.canCombindRestaurantData.selectValue;
        if (value === '') {
            obj = {}
        } else {
            obj = { [key]: value }
        }
        const params = {
            is_belonged_group: this.canCombindRestaurantData.groupSelectVal === 'belonged_group' ? true : false,
            belonged_group: groupUnitData.belongedGroup,
            pagination_per_page: this.canCombindRestaurantData.paginationPerPage,
            pagination_page: this.canCombindRestaurantData.currentPage,
            ...obj
        };
        const data = await apiManage.get_restaurant_condition(params);
        this.updateCanCombindRestaurantList(data);
        this.setTableLoading(false);
    }
    closeCanCombindRestaurantDialog() {
        this.setViewCanCombindRestaurantDialog(false)
        this.canCombindRestaurantData.currentPage = 1;
        this.canCombindRestaurantData.paginationPerPage = 999;
        this.canCombindRestaurantData.selectValue = '';
        this.canCombindRestaurantData.groupSelectVal = '';
        this.canCombindRestaurantData.currentSearchValue = '';
    }
    // 绑定餐厅配置数据
    canCombindRestaurantData: {
        currentPage: number, paginationPerPage: number, list: IObservableArray<Restaurant>, isLoading: boolean,
        totalCount: number, open: boolean, selectValue: string, groupSelectVal: string, currentSearchValue: string
    } = {
            currentPage: 1, paginationPerPage: 999, list: observable<Restaurant>([]), totalCount: 0, isLoading: false, open: false,
            selectValue: 'nickname', currentSearchValue: '', groupSelectVal: 'belonged_group'
        }
    // --------------- 绑定餐厅 -------------
    // ------------- end-region -------------
}


export default EditAccountMobx;